import React, {Component} from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import './SweetAlert.css';



class Alert extends Component {
    state = {
        show: this.props.show
    }
       
    

    render(){
        return(
          this.state.show ? <SweetAlert style = {{width: '400px', marginLeft: '-210px'}}
              type = {this.props.type}
              onConfirm={() => {this.setState({show: false}); if(this.props.handleOk) {this.props.handleOk(false)}}}
              confirmBtnBsStyle = "none"
              confirmBtnCssClass = 'confirmButtonStyle'
              title=""
              showConfirm={true}
              >
                <span>{this.props.msg}</span>
                </SweetAlert> : null
        );
    }
}


export default Alert;